import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Application, BuzzyearsTemplateModule, ConfigurationService, JWTSettings } from 'buzzyears.ui';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { WorkflowUILibraryModule } from '../library';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfigurationService extends ConfigurationService {
  get platformEndpoint(): string {
    return environment.platformUrl;
  }

  get jwtSettings(): JWTSettings {
    return {
      domain: environment.jwtCookieDomain
    };
  }

  get application(): Application {
    return Application.create('Workflow', 1001);
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    WorkflowUILibraryModule,
    BuzzyearsTemplateModule.forRoot()
  ],
  providers: [ { provide: ConfigurationService, useClass: AppConfigurationService } ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts